var map = {
	"./close.svg": "3adf",
	"./copy-link.svg": "a070",
	"./customize.svg": "7253",
	"./delete.svg": "3930",
	"./duplicate.svg": "7324",
	"./edit.svg": "74af",
	"./global.svg": "e76c",
	"./info.svg": "22dd",
	"./list.svg": "b3cd",
	"./new-tab.svg": "11ed",
	"./preview-icon.svg": "8a1b",
	"./preview.svg": "ca1b",
	"./publish.svg": "d6b9",
	"./save.svg": "1954",
	"./survey-is-created.svg": "b5b3",
	"./survey-is-saved.svg": "56c5",
	"./translate.svg": "50a6",
	"./write.svg": "d57f",
	"./x.svg": "4cf3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d0df";